import { QuestionType } from "../Components/Pages/Unit-Intro/QuestionEnum";
import { axiosObj } from "./axios";




export const getAllQuestionByUnitId = async (unitId: string, offset: string, count: string, accessToken: string): Promise<any> => {
  const getAllQuestion = axiosObj.get(`/questions/getQuestionsByUnitId?unit_id=${unitId}&offset=${offset}&count=${count}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    }
  });
  return (await getAllQuestion).data
};

export const getAllQuestionByUnitIdAndType = async (unitId: string, gradeId: string, difficulty_level_Id: string, offset: string, count: string, accessToken: string): Promise<any> => {
  const getAllQuestion = axiosObj.get(`/questions/by-unit-and-difficulty?unit_id=${unitId}&grade_id=${gradeId}&difficulty_level_Id=${difficulty_level_Id}&question_category=RANDOM&offset=${offset}&count=${count}&orderBy=DESC`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    }
  });
  return (await getAllQuestion).data
};

export const createUnitInfo = async (formData: FormData, accessToken: string): Promise<any> => {
  const createUnitInfoResponse = axiosObj.post(`/difficulty-level/createIntro`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return (await createUnitInfoResponse).data
};


export const getAllUnitInfo = async (unitId: string, accessToken: string): Promise<any> => {
  const createUnitInfoResponse = axiosObj.get(`/difficulty-level/introByUnitId?unitId=${unitId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });
  return (await createUnitInfoResponse).data
}

export const getIntroByLevelIdAndUnitId = async (introId: string, unitId: string, accessToken: string): Promise<any> => {
  const createUnitInfoResponse = axiosObj.get(`/difficulty-level/introByUnityAndLevel?level=${introId}&unitId=${unitId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",

    },
  });
  return (await createUnitInfoResponse).data
}

export const getIntroDataByIntroId = async (introId: string, accessToken: string): Promise<any> => {
  const createUnitInfoResponse = axiosObj.get(`/difficulty-level/intro/{id}?id=${introId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",

    },
  });
  return (await createUnitInfoResponse).data
}

export const updateIntro = async (formData: FormData, accessToken: string): Promise<any> => {
  const updateUnitInfoResponse = axiosObj.put(`/difficulty-level/updateIntro`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return (await updateUnitInfoResponse).data
}

export const deleteIntroByIntroId = async (data: { "ids": {} }, accessToken: string): Promise<any> => {
  const deleteUnitInfoResponse = await axiosObj.delete(`/difficulty-level/deleteIntro`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    data,
  });
  return deleteUnitInfoResponse.data;
};



export const createQuestion = async (formData: FormData, accessToken: string): Promise<any> => {
  const createQuestionResponse = axiosObj.post(`/questions/create`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return (await createQuestionResponse).data
}

export const createKaraokeVideo = async (formData: FormData, accessToken: string): Promise<any> => {
  const createQuestionResponse = axiosObj.post(`/karaoke/upload`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return (await createQuestionResponse).data
}

export const getKaraokeVideo = async (data: any, accessToken: string): Promise<any> => {
  const { unit_id, grade_id } = data;
  const createQuestionResponse = axiosObj.get(`/karaoke/list/${unit_id}/${grade_id}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return (await createQuestionResponse).data
}

export const checkCongratulationData = async (data: any, accessToken: string): Promise<any> => {
  const { difficulty_level_Id, unit_id, challenge_type } = data;
  const createQuestionResponse = axiosObj.get(`/questions/check-congratulation/${difficulty_level_Id}/${unit_id}/${challenge_type}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });
  return (await createQuestionResponse).data

}




export const updateQuestion = async (formData: FormData, accessToken: string): Promise<any> => {
  const createQuestionResponse = axiosObj.put(`/questions/update`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return (await createQuestionResponse).data
}


export const createCongratsData = async (formData: FormData, accessToken: string): Promise<any> => {
  const createCongratsResponse = axiosObj.post(`questions/save-congratulation`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return (await createCongratsResponse).data
}

export const updateCongratsData = async (formData: FormData, accessToken: string): Promise<any> => {
  const updateCongratsResponse = axiosObj.put(`questions/update-congratulation`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return (await updateCongratsResponse).data
}

export const createInstructionData = async (formData: FormData, accessToken: string): Promise<any> => {
  const createCongratsResponse = axiosObj.post(`questions/save-instructions`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return (await createCongratsResponse).data
}

export const updateInstructionData = async (formData: FormData, accessToken: string): Promise<any> => {
  const updateCongratsResponse = axiosObj.put(`questions/update-instruction`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return (await updateCongratsResponse).data
}

export const getQuestionByQuestionId = async (questionId: string, accessToken: string): Promise<any> => {
  const getQuestionByQuestionIdResponse = axiosObj.get(`/questions/getQuestionsById/{questionId}?questionId=${questionId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });
  return (await getQuestionByQuestionIdResponse).data
}

export const deleteQuestionByQuestionId = async (questionId: string, accessToken: string): Promise<any> => {
  const deleteQuestionByQuestionIdResponse = axiosObj.delete(`/questions/deleteQuestion?id=${questionId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });
  return (await deleteQuestionByQuestionIdResponse).data
}

//Search Tribe with offset limit and Count 
export const searchQuestion = async (unitId: string, searchText: string, status: string, type: QuestionType, difficulty_level_id: string, startDate: string | null, endDate: string | null, offset: string,
  count: string, accessToken: string) => {
  const queryParams = new URLSearchParams();

  if (type) queryParams.append("question_type", type)
  if (difficulty_level_id) queryParams.append("difficulty_level_Id", difficulty_level_id)
  queryParams.append("category", "RANDOM")
  queryParams.append("unit_id", unitId)
  queryParams.append("offset", offset);
  queryParams.append("count", count);

  const url = `questions/searchQuestionByFilter?${queryParams.toString()}`;

  try {
    const response = await axiosObj.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    ////////console.error("Error in searchTribe API:", error);
    throw error;
  }
};





//Challenges API
export const GetAllChallenges = async (unitId: string, gradeId: string, challengeType: string, offset: string, count: string, accessToken: string) => {
  const GetAllChallengesResponse = axiosObj.get(`/questions/getChallengesQuestionsByUnitId?unitId=${unitId}&difficultyId=4&gradeId=${gradeId}&challenge_type=${challengeType}&offset=${offset}&count=${count}&orderBy=DESC`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    }
  });
  return (await GetAllChallengesResponse).data
};


export const getChallengeUnitList = async (challengeType: string, accessToken: string) => {
  const ChallenegUnitListResponse = axiosObj.get(`/units/getUnitList?type=${challengeType}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });
  return (await ChallenegUnitListResponse).data
}

export const updateKaraokeVideo = async (karaokeVideoId: string, formData: any, accessToken: string) => {
  const updateKaraokeResponse = axiosObj.put(`/karaoke/edit/${karaokeVideoId}`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return (await updateKaraokeResponse).data
}

export const GetAllChallengesUnits = async (offset: string, count: string, ChallengeType: string, accessToken: string) => {
  const GetAllChallengesUnitResponse = axiosObj.get(`units/getChallengesQuestions?offset=${offset}&count=${count}&type=${ChallengeType}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    }
  });
  return (await GetAllChallengesUnitResponse).data
};


export const DeletAllChallengesByUnitId = async (unitId: string, challenge_type : string, accessToken: string) => {

  const DeletAllChallengesByUnitIdResponse = axiosObj.delete(`/questions/deleteChallengesByUnitId?id=${unitId}&type=${challenge_type}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    }
  });
  return (await DeletAllChallengesByUnitIdResponse).data
};